class NotificationDrawer {
  constructor() {
    this.drawer = null;
    this.overlay = null;
    this.currentProduct = null;
    this.currentVariant = null;
    this.buttonUpdateTimeout = null;
    this.init();
  }

  init() {
    this.createDrawerHTML();
    this.bindEvents();
    this.handleVariantChanges();
    this.initializeButtonState();
    this.checkForSuccessMessage();
    // Ensure sold out button is always enabled for notification drawer
    setTimeout(() => {
      const addButton = document.querySelector('button[name="add"]');
      if (addButton && addButton.hasAttribute('data-soldout')) {
        addButton.removeAttribute('disabled');
      }
    }, 1000);
  }

  initializeButtonState() {
    // Set initial button state on page load with multiple attempts
    let attempts = 0;
    const maxAttempts = 10;
    
    const tryUpdateState = () => {
      attempts++;
      const variantInput = document.querySelector('input[name="id"]');
      const variantData = variantInput ? this.getVariantData(variantInput.value) : null;
      
      if (variantData || attempts >= maxAttempts) {
        this.updateCurrentVariant();
        this.updateButtonState();
      } else {
        setTimeout(tryUpdateState, 200);
      }
    };
    
    setTimeout(tryUpdateState, 100);
  }

  checkForSuccessMessage() {
    // Check if URL contains contact_posted=true
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('contact_posted') === 'true') {
      // Remove the parameter from URL
      const newUrl = new URL(window.location.href);
      newUrl.searchParams.delete('contact_posted');
      window.history.replaceState({}, '', newUrl.toString());
      
      // Open drawer with success message
      setTimeout(() => {
        this.openWithSuccessMessage();
      }, 500);
    }
  }

  async openWithSuccessMessage() {
    // Get current product and variant data
    this.updateProductData();
    
    // Show drawer
    this.overlay.classList.add('active');
    this.drawer.classList.add('active');
    
    // Lock body scroll
    document.body.style.overflow = 'hidden';
    
    // Load success content
    this.showSuccessMessageInDrawer();
  }

  showSuccessMessageInDrawer() {
    const content = this.drawer.querySelector('#notification-drawer-content');
    const productTitle = this.escapeHtml(this.currentProduct.title);
    const variantTitle = this.escapeHtml(this.currentVariant.title);
    
    content.innerHTML = `
      <div data-product-notification-heading>
        <h2 class="product__notification__title h3">${productTitle}</h2>
        ${this.currentVariant.title !== 'Default Title' ? 
          `<p class="product__notification__variant subheading" data-variant-title>${variantTitle}</p>` : 
          ''
        }
      </div>
      
      <div class="product__notification__message">
        <p>Дякуємо! Ми повідомимо вас, коли товар буде в наявності.</p>
      </div>
      
      <form action="/contact" method="post" id="NotificationFormSuccess--${this.currentVariant.id}" data-notification-form data-variant-id="${this.currentVariant.id}" accept-charset="UTF-8">
        <input type="hidden" name="form_type" value="contact">
        <input type="hidden" name="utf8" value="✓">
        <input type="hidden" name="return_to" value="${window.location.pathname}?contact_posted=true">
        
        <div class="product__notification__form">
          <label for="NotificationFormNameSuccess" class="visually-hidden">Ім'я</label>
          <input type="text" class="contactFormName field" id="NotificationFormNameSuccess" name="contact[name]" placeholder="Ім'я" autocapitalize="words" required>

          <label for="NotificationFormPhoneSuccess" class="visually-hidden">Номер телефону</label>
          <input type="tel" class="contactFormPhone field" id="NotificationFormPhoneSuccess" name="contact[phone]" placeholder="Номер телефону" pattern="[0-9\\-\\+\\s\\(\\)]*" required>

          <label for="NotificationFormEmailSuccess" class="visually-hidden">Ваша електронна пошта</label>
          <input type="email" class="contactFormEmail field" id="NotificationFormEmailSuccess" name="contact[email]" placeholder="Ваша електронна пошта" autocorrect="off" autocapitalize="off" required>

          <label for="NotificationFormProductSuccess" class="visually-hidden">Повідомлення про товар</label>
          <input type="hidden" id="NotificationFormProductSuccess" name="contact[повідомлення-про-товар]" autocapitalize="words" value="${productTitle} - ${variantTitle}" data-notification-product>

          <button type="submit" name="subscribe" class="btn btn--primary btn--solid">
            <span>ОФОРМИТИ ПЕРЕДЗАМОВЛЕННЯ</span>
          </button>
          
          <button type="button" class="btn btn--secondary btn--solid" onclick="notificationDrawer.close()" style="margin-top: 10px;">
            Закрити
          </button>
                 </div>
       </form>
     `;
     
     // Bind form submit event for success form
     const form = content.querySelector('form');
     if (form) {
       form.addEventListener('submit', (e) => this.handleFormSubmit(e));
     }
   }

  createDrawerHTML() {
    // Create overlay
    this.overlay = document.createElement('div');
    this.overlay.className = 'notification-drawer__overlay';
    this.overlay.addEventListener('click', () => this.close());

    // Create drawer
    this.drawer = document.createElement('div');
    this.drawer.className = 'notification-drawer';
    this.drawer.innerHTML = `
      <div class="notification-drawer__header">
        <button type="button" class="notification-drawer__close" aria-label="Закрити">&times;</button>
        <h2>Повідомити коли буде в наявності</h2>
      </div>
      <div class="notification-drawer__content" id="notification-drawer-content">
        <!-- Content will be loaded here -->
      </div>
    `;

    // Add close button event
    this.drawer.querySelector('.notification-drawer__close').addEventListener('click', () => this.close());

    // Append to body
    document.body.appendChild(this.overlay);
    document.body.appendChild(this.drawer);
  }

  bindEvents() {
    // Listen for soldout button clicks
    document.addEventListener('click', (e) => {
      if (e.target.matches('button[name="add"]') || e.target.closest('button[name="add"]')) {
        const button = e.target.matches('button[name="add"]') ? e.target : e.target.closest('button[name="add"]');
        
        // Check if product is sold out
        const isSoldOut = this.isProductSoldOut();
        
        if (isSoldOut) {
          e.preventDefault();
          e.stopPropagation();
          button.classList.remove('loading'); // no cart request follows, so nothing else would clear it
          this.open();
          return false;
        }
      }
    });

    // Also listen for form submit events to catch any missed cases
    document.addEventListener('submit', (e) => {
      if (e.target.matches('form[data-type="add-to-cart-form"]')) {
        const button = e.target.querySelector('button[name="add"]');
        if (button && (button.hasAttribute('data-soldout') || this.isProductSoldOut())) {
          e.preventDefault();
          e.stopPropagation();
          this.open();
        }
      }
    });

    // Escape key to close
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen()) {
        this.close();
      }
    });
  }

  handleVariantChanges() {
    // Listen for variant picker changes
    document.addEventListener('change', (e) => {
      if (e.target.matches('input[name="id"]') || e.target.matches('select[name="id"]')) {
        // Small delay to ensure variant data is updated
        setTimeout(() => {
          this.updateCurrentVariant();
          this.updateButtonState();
        }, 100);
      }
    });

    // Listen for variant option changes (radio buttons, selects, etc.)
    document.addEventListener('change', (e) => {
      if (e.target.matches('input[type="radio"][name*="option"]') || 
          e.target.matches('select[name*="option"]')) {
        setTimeout(() => {
          this.updateCurrentVariant();
          this.updateButtonState();
        }, 100);
      }
    });

    // Also listen for any variant-related changes
    document.addEventListener('change', (e) => {
      if (e.target.form && e.target.form.matches('form[data-type="add-to-cart-form"]')) {
        setTimeout(() => {
          this.updateCurrentVariant();
          this.updateButtonState();
        }, 150);
      }
    });

    // Listen for custom variant change events that might be triggered by the theme
    document.addEventListener('variant:change', () => {
      setTimeout(() => {
        this.updateCurrentVariant();
        this.updateButtonState();
        setTimeout(() => {
          const addButton = document.querySelector('button[name="add"]');
          if (addButton && addButton.hasAttribute('data-soldout')) {
            addButton.removeAttribute('disabled');
          }
        }, 1000);
        
      }, 100);
    });

    // Observe changes to the hidden variant ID input
    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput) {
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
            this.updateCurrentVariant();
            this.updateButtonState();
          }
        });
      });
      
      observer.observe(variantInput, { 
        attributes: true, 
        attributeFilter: ['value'] 
      });

      // Also observe for the value property change
      let lastValue = variantInput.value;
      setInterval(() => {
        if (variantInput.value !== lastValue) {
          lastValue = variantInput.value;
          this.updateCurrentVariant();
          this.updateButtonState();
        }
      }, 500);
    }
  }

  updateCurrentVariant() {
    // Get current variant data from the page
    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput) {
      const variantData = this.getVariantData(variantInput.value);
      this.currentVariant = {
        id: variantInput.value,
        available: variantData ? variantData.available : false,
        title: this.getVariantTitle()
      };
    }
  }

  getVariantData(variantId) {
    // Get variant data from the JSON script - try multiple selectors
    const variantScripts = document.querySelectorAll('script[type="application/json"]');
    
    for (let script of variantScripts) {
      try {
        const data = JSON.parse(script.textContent);
        // Check if this is variant data (array with variant objects)
        if (Array.isArray(data) && data.length > 0 && data[0].id) {
          const variant = data.find(variant => variant.id.toString() === variantId.toString());
          if (variant) {
            return variant;
          }
        }
      } catch (e) {
        // Continue to next script if parsing fails
        continue;
      }
    }
    
    // Also check for variant data in window object
    if (window.variantData) {
      return window.variantData.find(variant => variant.id.toString() === variantId.toString());
    }
    
    return null;
  }

  updateButtonState() {
    // Clear existing timeout to prevent flickering
    if (this.buttonUpdateTimeout) {
      clearTimeout(this.buttonUpdateTimeout);
    }
    
    // Add small delay to prevent flickering during rapid variant changes
    this.buttonUpdateTimeout = setTimeout(() => {
      this.doUpdateButtonState();
    }, 200);
  }

  doUpdateButtonState() {
    const addButton = document.querySelector('button[name="add"]');
    const buttonText = addButton?.querySelector('.cta');
    
    if (!addButton || !buttonText) return;

    const variantInput = document.querySelector('input[name="id"]');
    if (!variantInput) return;

    const variantData = this.getVariantData(variantInput.value);
    const isAvailable = variantData && variantData.available;

    if (isAvailable) {
      // Available variant
      addButton.removeAttribute('data-soldout');
      buttonText.textContent = (window.variantStrings && window.variantStrings.addToCart) || 'Додати в кошик'; // same label as the theme renders
    } else {
      // Sold out variant
      addButton.setAttribute('data-soldout', 'true');
      buttonText.textContent = 'ОФОРМИТИ ПЕРЕДЗАМОВЛЕННЯ'; // Pre-order text
    }
  }

  isProductSoldOut() {
    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput) {
      const variantData = this.getVariantData(variantInput.value);
      return variantData && !variantData.available;
    }
    
    // Fallback to button attribute
    const addButton = document.querySelector('button[name="add"]');
    return addButton && addButton.hasAttribute('data-soldout');
  }

  async open() {
    // Get current product and variant data
    this.updateProductData();
    
    // Load form content
    await this.loadFormContent();
    
    // Show drawer
    this.overlay.classList.add('active');
    this.drawer.classList.add('active');
    
    // Lock body scroll
    document.body.style.overflow = 'hidden';
    
    // Focus first input
    setTimeout(() => {
      const firstInput = this.drawer.querySelector('input[type="text"], input[type="email"]');
      if (firstInput) {
        firstInput.focus();
      }
    }, 300);
  }

  close() {
    this.overlay.classList.remove('active');
    this.drawer.classList.remove('active');
    document.body.style.overflow = '';
  }

  isOpen() {
    return this.drawer.classList.contains('active');
  }

  updateProductData() {
    // Get product data from the page
    const productTitleElement = document.querySelector('.title h1, .title h2');
    const productTitle = productTitleElement ? productTitleElement.textContent.trim() : '';
    const variantInput = document.querySelector('input[name="id"]');
    const variantTitle = this.getVariantTitle();
    
    this.currentProduct = {
      title: productTitle,
      id: variantInput ? variantInput.form?.getAttribute('data-product-id') : null
    };
    
    this.currentVariant = {
      id: variantInput ? variantInput.value : null,
      title: variantTitle
    };
  }

  getVariantTitle() {
    // First try to get from variant data
    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput) {
      const variantData = this.getVariantData(variantInput.value);
      if (variantData && variantData.public_title && variantData.public_title !== 'Default Title') {
        return variantData.public_title;
      }
    }

    // Fallback: Try to get variant title from variant picker
    const selectedOptions = [];
    
    // Check radio inputs
    const radioInputs = document.querySelectorAll('input[type="radio"]:checked[name*="option"]');
    radioInputs.forEach(input => {
      if (input.value && input.value !== '') {
        selectedOptions.push(input.value);
      }
    });
    
    // Check select inputs
    const selectInputs = document.querySelectorAll('select[name*="option"]');
    selectInputs.forEach(select => {
      if (select.value && select.value !== '') {
        selectedOptions.push(select.value);
      }
    });
    
    return selectedOptions.length > 0 ? selectedOptions.join(' / ') : 'Default Title';
  }

  async loadFormContent() {
    const content = this.drawer.querySelector('#notification-drawer-content');
    
    // Create form HTML directly since we have the snippet
    const productTitle = this.escapeHtml(this.currentProduct.title);
    const variantTitle = this.escapeHtml(this.currentVariant.title);
    
    const formHTML = `
      <div data-product-notification-heading>
        <h2 class="product__notification__title h3">${productTitle}</h2>
        ${this.currentVariant.title !== 'Default Title' ? 
          `<p class="product__notification__variant subheading" data-variant-title>${variantTitle}</p>` : 
          ''
        }
      </div>
      
             <form action="/contact" method="post" id="NotificationForm--${this.currentVariant.id}" data-notification-form data-variant-id="${this.currentVariant.id}" accept-charset="UTF-8">
         <input type="hidden" name="form_type" value="contact">
         <input type="hidden" name="utf8" value="✓">
         <input type="hidden" name="return_to" value="${window.location.pathname}?contact_posted=true">
        
        <div class="product__notification__form">
          <label for="NotificationFormName" class="visually-hidden">Ім'я</label>
          <input type="text" class="contactFormName field" id="NotificationFormName" name="contact[name]" placeholder="Ім'я" autocapitalize="words" required>

          <label for="NotificationFormPhone" class="visually-hidden">Номер телефону</label>
          <input type="tel" class="contactFormPhone field" id="NotificationFormPhone" name="contact[phone]" placeholder="Номер телефону" pattern="[0-9\\-\\+\\s\\(\\)]*" required>

          <label for="NotificationFormEmail" class="visually-hidden">Ваша електронна пошта</label>
          <input type="email" class="contactFormEmail field" id="NotificationFormEmail" name="contact[email]" placeholder="Ваша електронна пошта" autocorrect="off" autocapitalize="off" required>

          <label for="NotificationFormProduct" class="visually-hidden">Повідомлення про товар</label>
          <input type="hidden" id="NotificationFormProduct" name="contact[повідомлення-про-товар]" autocapitalize="words" value="${productTitle} - ${variantTitle}" data-notification-product>

          <button type="submit" name="subscribe" class="btn btn--primary btn--solid">
            <span>ОФОРМИТИ ПЕРЕДЗАМОВЛЕННЯ</span>
          </button>
        </div>
      </form>
    `;
    
    content.innerHTML = formHTML;
    
    // Bind form submit event
    const form = content.querySelector('form');
    if (form) {
      form.addEventListener('submit', (e) => this.handleFormSubmit(e));
    }
  }

  async handleFormSubmit(e) {
    const form = e.target;
    const submitButton = form.querySelector('button[type="submit"]');
    
    // Hide any existing error messages immediately
    const existingErrors = document.querySelectorAll('.form-errors');
    existingErrors.forEach(error => error.remove());
    
    // Show loading state
    if (submitButton) {
      submitButton.classList.add('loading');
      submitButton.disabled = true;
    }
    
    // Let the form submit naturally - Shopify will handle the redirect
    // The form already has the return_to parameter set
  }

  showSuccessMessage() {
    const content = this.drawer.querySelector('#notification-drawer-content');
    content.innerHTML = `
      <div class="product__notification__message">
        <p>Дякуємо! Ми повідомимо вас, коли товар буде в наявності.</p>
      </div>
      <button type="button" class="btn btn--primary btn--solid" onclick="notificationDrawer.close()">
        Закрити
      </button>
    `;
  }

  showErrorMessage() {
    const content = this.drawer.querySelector('#notification-drawer-content');
    const existingError = content.querySelector('.form-errors');
    
    if (!existingError) {
      const errorDiv = document.createElement('div');
      errorDiv.className = 'form-errors';
      errorDiv.innerHTML = '<p>Виникла помилка. Спробуйте ще раз.</p>';
      content.insertBefore(errorDiv, content.firstChild);
    }
  }

  escapeHtml(text) {
    const map = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;'
    };
    return text ? text.replace(/[&<>"']/g, (m) => map[m]) : '';
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  window.notificationDrawer = new NotificationDrawer();
});

// Also initialize if DOM is already loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    if (!window.notificationDrawer) {
      window.notificationDrawer = new NotificationDrawer();
    }
  });
} else {
  if (!window.notificationDrawer) {
    window.notificationDrawer = new NotificationDrawer();
  }
} 